// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__JJkHW","label":"Completed_label__2agqx"};